import { getCurrencySymbol } from "../../../../config/selectors";
import { selectSearchState } from "../../selectors/shared";

const emptyObject = {};
export const defaultStep = 5;

export const getStateForPriceSlider = state => {
  const { min, max, step, selected } = state.search.range.currentprice;
  const hasSelectedValues = isCurrentPriceRangeSelected(state);

  return {
    minValue: min,
    maxValue: max,
    step,
    hasSelectedValues,
    value: {
      min: selected.temp
        ? selected.temp.leftIndicator
        : selected.current.leftIndicator,
      max: selected.temp
        ? selected.temp.rightIndicator
        : selected.current.rightIndicator
    }
  };
};

export const getPriceRangeState = state => state.search.range.currentprice;

export const getNextPriceRange = state =>
  state.search.range.currentprice.selected.temp
    ? state.search.range.currentprice.selected.temp
    : state.search.range.currentprice.selected.current;

export const getPrevPriceRange = state =>
  state.search.range.currentprice.selected.previous;

export const isCurrentPriceRangeSelected = state =>
  getPriceRangeState(state).hasSelectedValues;

export const getPriceRange = state => state.facets.filter(isFacetPriceRange);

export const isFacetPriceRange = facet => facet.id === "currentprice";

export const getPrices = facetValue => Number(facetValue.id);

export const getLowerStep = (prices, step = defaultStep) =>
  Math.floor(Math.min(...prices) / step) * step;

export const getHigherStep = (prices, step = defaultStep) =>
  Math.ceil(Math.max(...prices) / step) * step;

export const isPriceRangeSelected = state =>
  getPriceRange(state).every(facet => facet.hasSelectedValues);

export const getMinMaxFromApiResponse = state =>
  getPriceRange(state)
    .map(({ facetValues }) => {
      const prices = facetValues.map(getPrices);

      return {
        min: getLowerStep(prices),
        max: getHigherStep(prices)
      };
    })
    .concat({
      min: null,
      max: null
    })
    .reduce(first => first);

export const calculateHasSelectedValuesState = (
  indicatorValues,
  currentpriceState
) =>
  indicatorValues && currentpriceState
    ? indicatorValues.leftIndicator !== currentpriceState.min ||
      indicatorValues.rightIndicator !== currentpriceState.max
    : false;

export const selectSearchPriceRangeDomain = state => {
  const search = selectSearchState(state);

  return {
    range: search.range ?? emptyObject
  };
};

const formatPriceRangeName = (currencySymbol, min, max) =>
  `${currencySymbol}${min} - ${currencySymbol}${max}`;

const getPriceRangeValues = (value, minValue, maxValue) => {
  const hasSelectedMin = value?.min > minValue;
  const hasSelectedMax = value?.max < maxValue;

  if (!hasSelectedMin && !hasSelectedMax) {
    return null;
  }

  return {
    min: hasSelectedMin ? value.min : minValue,
    max: hasSelectedMax ? value.max : maxValue
  };
};

export const getSelectedPriceRangeFacet = state => {
  const selectedPriceRange = getStateForPriceSlider(state);
  const currencySymbol = getCurrencySymbol(state);

  const { value, minValue, maxValue } = selectedPriceRange || {};
  const priceValues = getPriceRangeValues(value, minValue, maxValue);

  if (!priceValues) {
    return null;
  }

  const name = formatPriceRangeName(
    currencySymbol,
    priceValues.min,
    priceValues.max
  );

  return { id: "price", name };
};
